// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectionCard_container__3fUza","label":"SelectionCard_label__GXY5O","value":"SelectionCard_value__VrbTY","iconContainer":"SelectionCard_iconContainer__FjKYo"};